import Image from 'next/image';
import {type FC, useState} from 'react';
import type {Recruitment} from '../../../../core/repositories/recruitingInfoRepository';
import {CommonLink} from '../../../../shared/components/CommonLink';

type Props = {
  companyLogoURL: string;
  companyName: string;
  recruitmentList: Recruitment[];
};

/**
 * 募集通知のコンテンツ
 * 通知コンポーネントの外殻はMantineを使用
 */
export const NotificationContent: FC<Props> = ({
  companyLogoURL,
  companyName,
  recruitmentList,
}) => {
  const [showImage, setShowImage] = useState(true);
  const mainRecruitmentTitle = recruitmentList[0]?.title;
  const recruitingInfoPage = `/recruiting_info/${recruitmentList[0]?.category === 'archive' ? 'archives' : 'view'}/${recruitmentList[0]?.detailID}`;
  const hasRecruitments = recruitmentList.length > 1;

  return (
    <div className="w-full pc:w-[600px] flex gap-8 items-center justify-between">
      <div className="flex items-center">
        <div>
          {showImage && (
            <Image
              className="rounded-16 overflow-hidden line-clamp-1"
              src={companyLogoURL}
              width={40}
              height={40}
              alt={`${companyName}のメイン写真`}
              onError={() => {
                setShowImage(false);
              }}
            />
          )}
        </div>
        <div className="font-bold line-clamp-2">{mainRecruitmentTitle}</div>
      </div>
      <div>
        {hasRecruitments ? (
          <CommonLink href="#recruitment">
            <div className="px-16 py-8 w-full bg-primary text-white text-sm text-center font-bold rounded-[8px] text-nowrap hover:opacity-80 pc:w-[100px]">
              他{recruitmentList.length - 1}件
            </div>
          </CommonLink>
        ) : (
          <CommonLink href={recruitingInfoPage}>
            <div className="w-full px-16 py-8 bg-primary text-white text-sm text-center font-bold rounded-[8px] text-nowrap hover:opacity-80 pc:w-[100px]">
              募集を見る
            </div>
          </CommonLink>
        )}
      </div>
    </div>
  );
};
